import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { TenderSummary } from "./generated/api.schemas";

export const getTodayTenders = async (): Promise<TenderSummary[]> => {
  return customFetch<TenderSummary[]>("/api/tenders/today", { method: "GET" });
};

export const useGetTodayTenders = (
  options?: { query?: UseQueryOptions<TenderSummary[], unknown, TenderSummary[]> }
) => {
  const { query: queryOptions } = options ?? {};
  return useQuery<TenderSummary[], unknown, TenderSummary[]>({
    queryKey: ["todayTenders"],
    queryFn: getTodayTenders,
    ...queryOptions,
  });
};
